import { types as sdkTypes } from './util/sdkLoader';

const { LatLng: SDKLatLng, LatLngBounds: SDKLatLngBounds } = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
export default [
    // Madrid
    {
      id: 'default-madrid',
      predictionPlace: {
        address: 'Madrid, España',
        origin: new SDKLatLng(40.4167754, -3.7037902),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(41.3141470715387, -2.583048791022935),
          new SDKLatLng(39.551870596350746, -4.748226259407168)
        ),
        city: 'Madrid',
      },
    },
    // Barcelona
    {
      id: 'default-barcelona',
      predictionPlace: {
        address: 'Barcelona, España',
        origin: new SDKLatLng(41.3850639, 2.1734035),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(42.13818576, 2.88373514),
          new SDKLatLng(40.4942011, 1.15338846)
        ),
        city: 'Barcelona',
      },
    },
    // Valencia
    {
      id: 'default-valencia',
      predictionPlace: {
        address: 'Valencia, España',
        origin: new SDKLatLng(39.4699075, -0.3762881),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(40.83271072, 1.31116912),
          new SDKLatLng(37.43799861, -2.14952424)
        ),
        city: 'Valencia',
      },
    },
    // Sevilla
    {
      id: 'default-sevilla',
      predictionPlace: {
        address: 'Sevilla, España',
        origin: new SDKLatLng(37.3890924, -5.9844589),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(37.79551968212691, -5.486278814094459),
          new SDKLatLng(36.953429193338984, -6.4187103102832515)
        ),
        city: 'Sevilla',
      },
    },
    // Zaragoza
    {
      id: 'default-zaragoza',
      predictionPlace: {
        address: 'Zaragoza, España',
        origin: new SDKLatLng(41.6488226, -0.8890853),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(41.91513661345223, -0.5277616477363224),
          new SDKLatLng(41.38711012967156, -1.2592632571971665)
        ),
        city: 'Zaragoza',
      },
    },
    // Málaga
    {
      id: 'default-malaga',
      predictionPlace: {
        address: 'Málaga, España',
        origin: new SDKLatLng(36.721261, -4.4212655),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(37.59251361, -3.62064642),
          new SDKLatLng(35.83789808, -5.3509931)
        ),
        city: 'Málaga',
      },
    },
    // Murcia
    {
      id: 'default-murcia',
      predictionPlace: {
        address: 'Murcia, España',
        origin: new SDKLatLng(37.9922399, -1.1306544),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(38.20247561448229, -0.943192089416795),
          new SDKLatLng(37.75831012080431, -1.3100709154926014)
        ),
        city: 'Murcia',
      },
    },
    // Palma de Mallorca http://localhost:3000/s?address=Palma%20de%20Mallorca%2C%20Espa%C3%B1a&bounds=40.34581249%2C3.64436815%2C38.65688335%2C1.91402147&mapSearch=true
    {
      id: 'default-palma-de-mallorca',
      predictionPlace: {
        address: 'Palma de Mallorca, España',
        origin: new SDKLatLng(39.6013107, 2.6387795),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(40.34581249, 3.64436815),
          new SDKLatLng(38.65688335, 1.91402147)
        ),
        city: 'Palma de Mallorca',
      },
    },
    // Pamplona
    {
      id: 'default-pamplona',
      predictionPlace: {
        address: 'Pamplona, España',
        origin: new SDKLatLng(42.812526, -1.6457745),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(43.44697561, -1.10752386),
          new SDKLatLng(41.83686745, -2.83787054)
        ),
        city: 'Pamplona',
      },
    },
    // Bilbao
    {
      id: 'default-bilbao',
      predictionPlace: {
        address: 'Bilbao, España',
        origin: new SDKLatLng(43.2630126, -2.9349852),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(44.35422846, -1.34752229),
          new SDKLatLng(41.14032738, -4.80821565)
        ),
        city: 'Bilbao',
      },
    },
    // Tarragona
    {
      id: 'default-tarragona',
      predictionPlace: {
        address: 'Tarragona, España',
        origin: new SDKLatLng(41.1188827, 1.2444909),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(41.238263206305795, 1.5980570018981264),
          new SDKLatLng(41.01225550630217, 0.8803206824418512)
        ),
        city: 'Tarragona',
      },
    },
    // Salamanca
    {
      id: 'default-salamanca',
      predictionPlace: {
        address: 'Salamanca, España',
        origin: new SDKLatLng(40.9701039, -5.663539699999999),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(41.11474814280797, -5.402554795321315),
          new SDKLatLng(40.81152972784568, -5.9346719525054406)
        ),
        city: 'Salamanca',
      },
    },
    // Segovia
    {
      id: 'default-segovia',
      predictionPlace: {
        address: 'Segovia, España',
        origin: new SDKLatLng(40.9429032, -4.108806899999999),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(41.089915871083186, -3.9621763898262223),
          new SDKLatLng(40.792394787411695, -4.261566850081385)
        ),
        city: 'Segovia',
      },
    },
    // Toledo http://localhost:3000/s?address=Toledo%2C%20Espa%C3%B1a&bounds=40.28996281%2C-3.65393568%2C39.44994056%2C-4.51910902&mapSearch=true
    {
      id: 'default-toledo',
      predictionPlace: {
        address: 'Toledo, España',
        origin: new SDKLatLng(39.8628316, -4.027323099999999),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(40.28996281, -3.65393568),
          new SDKLatLng(39.44994056, -4.51910902)
        ),
        city: 'Toledo',
      },
    },
    // Córdoba
    {
      id: 'default-cordoba',
      predictionPlace: {
        address: 'Córdoba, España',
        origin: new SDKLatLng(37.8881751, -4.7793835),
        bounds: new SDKLatLngBounds(
          new SDKLatLng(38.14113608005919, -4.5154310491822365),
          new SDKLatLng(37.641440015350575, -5.051756583074176)
        ),
        city: 'Córdoba',
      },
    },
];
